var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 42.3333H30.667C32.5003 42.3333 34.0003 40.8333 34.0003 39V22.3333H39.3003C42.267 22.3333 43.767 18.7333 41.667 16.6333L26.367 1.33334C25.067 0.0333374 22.967 0.0333374 21.667 1.33334L6.36699 16.6333C4.26699 18.7333 5.73366 22.3333 8.70033 22.3333H14.0003V39C14.0003 40.8333 15.5003 42.3333 17.3337 42.3333ZM4.00033 49H44.0003C45.8337 49 47.3337 50.5 47.3337 52.3333C47.3337 54.1667 45.8337 55.6667 44.0003 55.6667H4.00033C2.16699 55.6667 0.666992 54.1667 0.666992 52.3333C0.666992 50.5 2.16699 49 4.00033 49Z",
    fill: "#0072CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.b9420b9828dbecda57c8a2354ce540f7.svg";
export { ForwardRef as ReactComponent };